import type { CustomSeriesRenderItemAPI } from 'echarts';

export function getLaneHeight(api: CustomSeriesRenderItemAPI): number {
  const size = api.size?.([0, 1]);

  if (Array.isArray(size)) {
    return Number(size[1] ?? 0);
  }

  return Number(size ?? 0);
}
